import { crudSelectorsCustom } from 'redux/crudCreatorCustom/selector';
import { MODEL_NAME } from './actions';

export const centresOfUserSelectors = crudSelectorsCustom(MODEL_NAME);
